import intl from 'react-intl-universal';
import classNames from 'classnames';
import { Typography } from '@getsynapse/design-system';

const ChartError = ({
  className,
}: {
  className?: string;
  errorCode?: number;
}) => {
  return (
    <div
      className={classNames(
        'h-full w-full flex flex-col items-center justify-center align-middle',
        className
      )}
      data-testid='chart-error'
    >
      <Typography variant='h4' weight='medium' className='mb-2'>
        {intl.get('INSIGHT.ERROR')}
      </Typography>
      <Typography variant='body' className='mb-4 text-center leading-7'>
        {intl.get('INSIGHT.ERROR_MESSAGE')}
      </Typography>
    </div>
  );
};

export default ChartError;
